// extracted by mini-css-extract-plugin
export default {"navbar":"style_navbar__dK1O4"};